/**
 * NavItem component
 * Individual navigation item for AppSidebar
 */

import { Link, useRouterState } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';

import { cx } from '@/utils/functions/cx';

import { useSidebarStore } from '../store/sidebar-store';
import './NavItem.scss';

interface NavItemProps {
  to: string;
  icon: LucideIcon;
  label: string;
}

export function NavItem({ to, icon: Icon, label }: NavItemProps) {
  const router = useRouterState();
  const isActive = router.location.pathname === to;
  const isExpanded = useSidebarStore((state) => state.isExpanded);

  return (
    <Link
      to={to}
      className={cx('nav-item', isActive && 'nav-item-active')}
      title={!isExpanded ? label : undefined}
    >
      <div className="nav-item-icon-wrapper">
        <Icon className="nav-item-icon" size={20} strokeWidth={2} />
      </div>
      {isExpanded && <span className="nav-item-label">{label}</span>}
    </Link>
  );
}
